declare global {
  interface Window {
    cmsPageVariant?: string;
  }
}

export type DeferSitenameCohort = 'variant-1' | 'control' | 'non-enrolled';

const cmsPageVariants = new Map<string, DeferSitenameCohort>([
  ['defer_sitename_confluence_treatment', 'variant-1'],
  ['defer_sitename_jsw_treatment', 'variant-1'],
  ['defer_sitename_confluence_control', 'control'],
  ['defer_sitename_jsw_control', 'control'],
  ['defer_sitename_confluence_non-enrolled', 'non-enrolled'],
  ['defer_sitename_jsw_non-enrolled', 'non-enrolled']
]);

export function getDeferSitenameExperimentCohort(): DeferSitenameCohort {
  if (window?.cmsPageVariant && cmsPageVariants.has(window.cmsPageVariant)) {
    return cmsPageVariants.get(window.cmsPageVariant) as DeferSitenameCohort;
  }

  return 'non-enrolled';
}
